import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Route, Routes } from "react-router-dom";
import DownloadCenterTable from "./table";
import { setDocumentTitle } from "@/lib/documentTitle";

import { Clients } from "@/lib/clients";
import { ClientTables } from "@/lib/clientTables";

export default function S3DownloadCenter() {
  const { t, i18n } = useTranslation(["titles"]);

  useEffect(() => {
    setDocumentTitle(
      t("quantilia_download_center", {
        ns: "titles",
        defaultValue: "Quantilia | Download Center",
      }),
    );
  }, [t, i18n.language]);

  return (
    <Routes>
      <Route
        index
        element={
          <DownloadCenterTable
            client={Clients.S3}
            table_name={ClientTables.S3_DOWNLOAD_CENTER}
          />
        }
      />
    </Routes>
  );
}
